import {html, LitElement} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import {Filterable} from './interfaces/filterable';

@customElement('ri-filter-entry')
export class FilterEntry extends LitElement {
  @state() filterable: Filterable | undefined;
  override render() {
    return html`${this.filterable}`;
  }
}
